import { orgInfoDetail } from './orgInfoReducer';

export const orgInfoAction = (query) => async (dispatch) => {
    try {
        dispatch(orgInfoDetail(query));
    } catch (err) {
        const error = {
            code: 0,
            message: typeof err == 'object' ? err.message : err,
        };
        throw error;
    }
};